"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("@uifabric/icons"), exports);
//# sourceMappingURL=Icons.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/Icons.js
// module id = 1066
// module chunks = 0